export const LEGAL_FORMS = {
    einzelunternehmen: "einzelunternehmen",
    eingetragenes_einzelunternehmen: "eingetragenes_einzelunternehmen",
    eingetragenes_gbr: "eingetragenes_gbr",
    gbr: "gbr",
    ohg: "ohg",
    kg: "kg",
    gmbh: "gmbh",
    ug: "ug",
    ag: "ag",
    verein: "verein",
    partg: "partg"
};
export const BUSINESS_LINES = {
    agriculture_forestry_and_fishing: "agriculture_forestry_and_fishing",
    mining: "mining",
    manufacturing: "manufacturing",
    energy_supply: "energy_supply",
    water_supply_and_waste_management: "water_supply_and_waste_management",
    construction: "construction",
    retail_trade: "retail_trade",
    wholesale_trade: "wholesale_trade",
    maintenance_and_repair_of_motor_vehicles: "maintenance_and_repair_of_motor_vehicles",
    transportation_and_storage: "transportation_and_storage",
    hospitality: "hospitality",
    information_and_communication: "information_and_communication",
    real_estate_and_housing: "real_estate_and_housing",
    financial_and_insurance_services: "financial_and_insurance_services",
    professional_scientific_and_technical_services: "professional_scientific_and_technical_services",
    education_and_training: "education_and_training",
    cosmetics_health_and_social_services: "cosmetics_health_and_social_services",
    arts_entertainment_and_recreation: "arts_entertainment_and_recreation",
    other_services: "other_services"
};
export const TITLES = {
    mr: "mr",
    mrs: "mrs",
    mx: "mx"
};
export const TRADE_REGISTERS = {
    hra: "HRA",
    hrb: "HRB"
};
export const customerTypes = {
    businessCustomer: "Business Customer",
    privateIndividual: "Private Individual"
};
export const COUNTRIES = {
    germany: "germany"
};
